import { getAssessmentMarking } from '../../services/data-entry/assessments.service'

export const UPDATE_ASSESSMENT_MARKING_LIST = 'UPDATE_ASSESSMENT_MARKING_LIST'
export const TOGGLE_ASSESSMENT_MARKING_LIST_LOADING = 'TOGGLE_ASSESSMENT_MARKING_LIST_LOADING'
export const ASSESSMENT_MARKING_LIST_ERROR = 'ASSESSMENT_MARKING_LIST_ERROR'
export const UPDATE_ASSESSMENT_MARKING_ANSWER = 'UPDATE_ASSESSMENT_MARKING_ANSWER'
export const UPDATE_ASSESSMENT_MARKING_RECORD = 'UPDATE_ASSESSMENT_MARKING_RECORD'
export const RESET_HAS_CHANGED_ASSESSMENT_MARKING_LIST = 'RESET_HAS_CHANGED_ASSESSMENT_MARKING_LIST'
export const RESET_ASSESSMENT_MARKING_STATE = 'RESET_ASSESSMENT_MARKING_STATE'
export const UPDATE_ASSESSMENT_MARKING_TOTAL_LIST = 'UPDATE_ASSESSMENT_MARKING_TOTAL_LIST'
export const TOGGLE_ASSESSMENT_MARKING_IS_SAVING = 'TOGGLE_ASSESSMENT_MARKING_IS_SAVING'
// MF-399 — rounds/milestones en la pantalla de marking
export const SET_ASSESSMENT_MARKING_ROUNDS = 'SET_ASSESSMENT_MARKING_ROUNDS'
export const SET_ASSESSMENT_MARKING_SELECTED_ROUND = 'SET_ASSESSMENT_MARKING_SELECTED_ROUND'

export const updateAssessmentMarkingRecord = (value = {}) => ({
  type: UPDATE_ASSESSMENT_MARKING_RECORD,
  payload: { name: 'value', value }
})

export const updateAssessmentMarkingAnswer = (value = {}) => ({
  type: UPDATE_ASSESSMENT_MARKING_ANSWER,
  payload: { name: 'value', value }
})

export const updateAssessmentMarkingList = (value = []) => ({
  type: UPDATE_ASSESSMENT_MARKING_LIST,
  payload: { name: 'list', value }
})

export const assessmentMarkingListError = (value = null) => ({
  type: ASSESSMENT_MARKING_LIST_ERROR,
  payload: { name: 'error', value }
})

export const toggleLoadingAssessmentMarking = (value = false) => ({
  type: TOGGLE_ASSESSMENT_MARKING_LIST_LOADING,
  payload: { name: 'loading', value }
})

export const toggleIsSavingAssessmentMarking = (value = false) => ({
  type: TOGGLE_ASSESSMENT_MARKING_IS_SAVING,
  payload: { name: 'saving', value }
})

export const resetHasChangedAssessmentMarking = (value = false) => ({
  type: RESET_HAS_CHANGED_ASSESSMENT_MARKING_LIST,
  payload: {}
})

export const resetAssessmentMarkingState = (value = false) => ({
  type: RESET_ASSESSMENT_MARKING_STATE,
  payload: {}
})

export const updateAssessmentMarkingTotalList = (value = 0) => ({
  type: UPDATE_ASSESSMENT_MARKING_TOTAL_LIST,
  payload: { value }
})

// MF-399 — guarda el registro de rounds del assessment (+ flag carry-forward) y
// fija un round seleccionado por defecto. rounds vacío = assessment legacy.
export const setAssessmentMarkingRounds = (rounds = [], carryForward = true) => ({
  type: SET_ASSESSMENT_MARKING_ROUNDS,
  payload: { rounds, carryForward }
})

// MF-399 — cambia el round activo en la grilla (re-proyecta los answers).
export const setAssessmentMarkingSelectedRound = (roundId = null) => ({
  type: SET_ASSESSMENT_MARKING_SELECTED_ROUND,
  payload: { roundId }
})

export const loadAssessmentMaking = (assessmentId = '', skip = 0, limit = 50, filter = {}) => {
  return async (dispatch) => {
    try {
      dispatch(toggleLoadingAssessmentMarking(true))
      dispatch(toggleIsSavingAssessmentMarking(false))
      dispatch(assessmentMarkingListError())

      const { data } = await getAssessmentMarking(assessmentId, skip, limit, filter)

      if (data) {
        // MF-399 — fijar rounds ANTES de la lista: la proyección por round del
        // reducer usa el selectedRoundId que setea esta acción.
        dispatch(setAssessmentMarkingRounds(data?.rounds ?? [], data?.carryForward ?? true))
        dispatch(updateAssessmentMarkingList(data?.paginatedResults ?? []))
        dispatch(updateAssessmentMarkingTotalList(data?.totalRecords ?? 0))

        return
      } else {
        dispatch(updateAssessmentMarkingList([]))
        dispatch(updateAssessmentMarkingTotalList(0))

        return
      }
    } catch (error) {
      dispatch(updateAssessmentMarkingList([]))
      dispatch(updateAssessmentMarkingTotalList(0))
    }
  }
}
